import { useEffect } from "react";

export const useBodyLock = (flag: boolean) => {
  useEffect(() => {
    if (!document.body) {
      // ignore, happens during page close
    } else if (flag) {
      document.body.classList.add("noScroll");
    } else {
      document.body.classList.remove("noScroll");
    }

    return () => document.body?.classList.remove("noScroll");
  }, [flag]);
};

